import Skeleton from "common/components/ui/Skeleton";

export default function LeadListSourcesSkeleton() {
  return (
    <div className="flex flex-row gap-2 overflow-hidden items-center p-1 -m-1">
      {Array.from({ length: 5 }).map((_, index) => (
        <div
          // biome-ignore lint/suspicious/noArrayIndexKey: no unique key
          key={index}
          className="w-[240px] shrink-0 p-4 bg-black-50 rounded-4xl flex flex-row items-center gap-3"
        >
          <Skeleton className="size-10 rounded-2xl" />

          <div className="flex flex-col gap-2 w-full">
            <Skeleton className="h-3.5 w-24" />
            <Skeleton className="h-3 w-16" />
          </div>
        </div>
      ))}
    </div>
  );
}
